import { render } from "./UserActivitesView.vue?vue&type=template&id=41f5a4ae"
import script from "./UserActivitesView.vue?vue&type=script&lang=js"
export * from "./UserActivitesView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__